import * as React from "react";

// import { useTheme } from '@mui/styles';
import {
  Box,
  MobileStepper,
  Paper,
  Typography,
  Button,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Radio,
  RadioGroup,
  useTheme,
  CircularProgress,
} from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { useSelector } from "react-redux";

export default function QuestionStepper({
  loader,
  questions = [],
  answers,
  onAnswerChange,
  onCancel,
  onDone,
}) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = questions.length;
  const { data: user } = useSelector((state) => state.user);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return questions.length && answers ? (
    <Box sx={{ flexGrow: 1 }}>
      <Box display="flex" px={2} pt={2} justifyContent="space-between">
        <Box>Questions</Box>
        <Box display="flex" columnGap={1}>
          {loader === false ? (
            <Button
              disabled={/^trial_user$/i.test(user.roles) ? true : false}
              variant="contained"
              color="primary"
              onClick={onDone}
              size="large"
              className="blue-button"
            >
              Done
            </Button>
          ) : (
            <CircularProgress></CircularProgress>
          )}
          <Button variant="contained" color="secondary" onClick={onCancel} className="black-border-button">
            Cancel
          </Button>
        </Box>
      </Box>
      <Box sx={{ height: 255, maxWidth: 400, width: "100%", p: 2 }}>
        <Typography>{questions[activeStep].question}</Typography>
        <br />
        {questions[activeStep].multiple ? (
          <FormGroup>
            {questions[activeStep].options.map((o, i) => (
              <FormControlLabel
                key={i}
                control={
                  <Checkbox
                    onChange={() => {
                      onAnswerChange(questions[activeStep].id, o, true);
                    }}
                  />
                }
                label={o}
                checked={answers[questions[activeStep]?.id]?.includes(o)}
              />
            ))}
          </FormGroup>
        ) : (
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            value={answers[questions[activeStep].id]}
            onChange={({ target }) => {
              onAnswerChange(questions[activeStep].id, target.value, false);
            }}
          >
            {questions[activeStep].options.map((o, i) => (
              <FormControlLabel
                key={i}
                control={<Radio />}
                value={o}
                label={o}
              />
            ))}
          </RadioGroup>
        )}
      </Box>
      <MobileStepper
        variant="text"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="large"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
    </Box>
  ) : (
    <></>
  );
}

function getAnswerTemplate(questions = []) {
  let temp = {};
  questions.forEach((q) => {
    if (q.multiple) temp[q.id] = [];
    else temp[q.id] = "";
  });
  return temp;
}
